export enum SignatoryOption {
  Self = 'SELF',
  Cosigner = 'COSIGNER',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
}
